module.exports = __webpack_public_path__ + "static/machine_learning-dbdac4d8e8240b67987313024eb970cf.png";